const localizationStore = {
	namespaced: true,
	state: () => ({
		me: 'localization',
		sandBox: null,
		sopifyStoreFrontAccessToken: 'c3ddcc0e43bb4e669cef10045abba8d4',
		userLanguage: 'en-US',
		supportedLanguages: {
			en: 'en-US',
			es: 'es-ES',
			ms: 'ms',
		},
		currencyCode: UserLocalization.currencyCode, //'USD',
		countryCode: UserLocalization.countryCode, //'TW'
		currencySymbol: UserLocalization.currencySybol,
	}),
	getters: {
		me: (state) => state.me,
		userLanguage: (state) => state.userLanguage,
		COUNTRY_SELECT: (state) =>
			COUNTRY_CODE_SELECT.filter((data) => {
				// if (
				// 	![
				// 		'Asia',
				// 		'Africa',
				// 		'Europe',
				// 		'Central America',
				// 		'South America',
				// 		'Oceania',
				// 		'North America',
				// 	].includes(data.continent)
				// ) {
				// 	console.log('country = ', data);
				// }
				// if (data.currencyCode === 'PR' || data.currencyCode === 'IN') {
				// 	console.log('PR and IN = ', data);
				// }
				// console.log('PR and IN = ', data.currencyCode);
				return data;
			}),
		shopCountriesArray: (state) => countriesList,
		shopUserLocalization: (state) => UserLocalization,
		currencyCode: (state) => state.currencyCode,
		countryCode: (state) => state.countryCode,
		currencySymbol: (state) => state.currencySymbol,
		regions: (state, getters) => {
			return {
				isUsCa: getters.isUS_CA,
				isAuNz: getters.isAU_NZ,
				isRu: getters.isRU,
				isCn: getters.isCN,
				isUsCaAuNzPrIn: getters.isUsCaAuNzPrIn,
				isLatam: getters.isLatam,
				isEurope: getters.isEurope,
				isUkGb: getters.isUkGb,
				isIndia: getters.isIndia,
			};
		},
		isIndia: (state, getters) => {
			return getters.countryCode.toUpperCase() === 'IN';
		},
		isUS_CA: (state, getters, rootState, rootGetters) => {
			return (
				getters.countryCode.toUpperCase() === 'US' || getters.countryCode.toUpperCase() === 'CA'
			);
		},
		isAU_NZ: (state, getters, rootState, rootGetters) => {
			return (
				getters.countryCode.toUpperCase() === 'AU' || getters.countryCode.toUpperCase() === 'NZ'
			);
		},
		isRU: (state, getters, rootState, rootGetters) => {
			return getters.countryCode.toUpperCase() === 'RU';
		},
		isCN: (state, getters, rootState, rootGetters) => {
			return getters.countryCode.toUpperCase() === 'CN';
		},
		isTW: (state, getters, rootState, rootGetters) => {
			return getters.countryCode.toUpperCase() === 'TW';
		},
		isUsCaAuNzPrIn: (state, getters) => {
			return ['US', 'CA', 'AU', 'NZ', 'IN', 'PR'].includes(getters.countryCode.toUpperCase());
		},
		isIreland: (state, getters) => {
			return ['IE', 'CZ', 'BG'].includes(getters.countryCode.toUpperCase());
		},
		isLatam: (state, getters) => {
			return [
				'AR',
				'BO',
				'BR',
				'CL',
				'CO',
				'CR',
				'CU',
				'DO',
				'EC',
				'SV',
				'GT',
				'HN',
				'MX',
				'NI',
				'PA',
				'PY',
				'PE',
				'UY',
				'VE',
			].includes(getters.countryCode.toUpperCase());
		},
		isEurope: (state, getters) => {
			return [
				'AD',
				'AL',
				'AM',
				'AT',
				'AX',
				'BA',
				'BE',
				'BG',
				'BY',
				'CH',
				'CY',
				'CZ',
				'DE',
				'DK',
				'EE',
				'ES',
				'FI',
				'FO',
				'FR',
				'GE',
				'GG',
				'GI',
				'GL',
				'GP',
				'GR',
				'HR',
				'HU',
				'IE',
				'IM',
				'IS',
				'IT',
				'JE',
				'LI',
				'LT',
				'LU',
				'LV',
				'MC',
				'MD',
				'ME',
				'MK',
				'MT',
				'NL',
				'NO',
				'PL',
				'PT',
				'RE',
				'RO',
				'RS',
				'SE',
				'SI',
				'SJ',
				'SK',
				'SM',
				'TR',
				'UA',
				'VA',
				'XK',
				'YT',
			].includes(getters.countryCode.toUpperCase());
		},
		isRestOfWorld: (state, getters) => {
			return !getters.isUsCaAuNzPrIn && !getters.isLatam && !getters.isEurope;
		},
		isUkGb: (state, getters) => {
			return ['UK', 'GB'].includes(getters.countryCode);
		},
		redirectLinkWhenHideStore: (state, getters) => {
			return `/pages/partner-and-distributors?search=${getters.countryCode}`;
		},
	},
	mutations: {
		setSandBox(state, data) {
			state.sandBox = data;
		},

		setLocale(state, data) {
			state.userLanguage = data;
		},

		setCurrencyCode(state, data) {
			state.currencyCode = data;
		},
		setCountryCode(state, data) {
			state.countryCode = data;
		},
	},
	actions: {
		sayHi() {
			appLog.log('HIIIIII localization');
		},

		setCurrencyCode({ commit }, code) {
			commit('setCurrencyCode', code);
		},

		setCountryCode({ commit }, code) {
			commit('setCountryCode', code);
		},

		async mergeObjects({ dispatch }, { target, source }) {
			let result = JSON.parse(JSON.stringify(target));
			for (const key in source) {
				if (source.hasOwnProperty(key)) {
					if (typeof source[key] === 'object' && source[key] !== null) {
						if (!result[key] || typeof result[key] !== 'object') {
							result[key] = {};
						}
						result[key] = await dispatch('mergeObjects', {
							target: result[key],
							source: source[key],
						}); // this.mergeObjects(result[key], source[key])
					} else {
						result[key] = source[key];
					}
				}
			}

			return result;
		},

		async fetchTranslations({ commit, dispatch }, { shopCdnUrl, elementId, locale }) {
			let jsonData = await fetch(
				`${shopCdnUrl}ack.data.translations.${elementId}.${locale}.json?v=latest`,
			).then((response) => {
				if (!response.ok) {
					throw new Error('Failed to fetch translations');
				}
				appLog.log('fetchTranslations OK');
				return response.json();
			});
			jsonData = window.ackNormalizeShopifyFileUrls
				? window.ackNormalizeShopifyFileUrls(jsonData)
				: jsonData;
			let baseMessages = i18n.messages[locale];
			appLog.log(baseMessages);
			//let jsonData = response.json()
			appLog.log(jsonData);
			let allMessages = await dispatch('mergeObjects', { target: baseMessages, source: jsonData });

			appLog.log(allMessages);
			i18n.setLocaleMessage(locale, allMessages);
			i18n.locale = locale;
			commit('setLocale', locale);
		},
		async fetchLocalTranslations({ commit, dispatch }, { productLocalJsonUrl, locale }) {
			let jsonData = await fetch(productLocalJsonUrl).then((response) => {
				if (!response.ok) {
					throw new Error('Failed to fetch translations');
				}
				appLog.log('fetchTranslations OK');
				return response.json();
			});
			jsonData = window.ackNormalizeShopifyFileUrls
				? window.ackNormalizeShopifyFileUrls(jsonData)
				: jsonData;

			let baseMessages = i18n.messages[locale];
			appLog.log(baseMessages);
			//let jsonData = response.json()
			appLog.log(jsonData);
			let allMessages = await dispatch('mergeObjects', { target: baseMessages, source: jsonData });
			appLog.log(allMessages);
			i18n.setLocaleMessage(locale, allMessages);
			i18n.locale = locale;
			commit('setLocale', locale);
		},
	},
};

vStore.registerModule('localization', localizationStore);
